import { Expose } from 'class-transformer';
import type TaxInterface from '../types/Tax';
import type BasketProduct from './BasketProduct';

export default class OrderDetail {
  @Expose() id: string = '';
  @Expose() order_guid: string = '';
  @Expose() order_id: string = '';
  @Expose() oloid: string = '';
  @Expose() store_number: number = 0;
  @Expose() time_placed: string = '';
  @Expose() time_wanted: string = '';
  @Expose() time_ready: string = '';
  @Expose() readytime: string = '';
  @Expose() customerhandoffcharge: number = 0;
  @Expose() delivery_method: string = '';
  @Expose() deliverymode: string = '';
  @Expose() num_items: number = 0;
  @Expose() subtotal: number = 0;
  @Expose() tax: number = 0;
  @Expose() taxes: TaxInterface[] = [];
  @Expose() tip: number = 0;
  @Expose() delivery: number = 0;
  @Expose() discount: number = 0;
  @Expose() total: number = 0;
  @Expose() customer_delivery: number = 0;
  @Expose() payment_type: string = '';
  @Expose() time_cancelled: string = '';
  @Expose() cancel_reason: string = '';
  @Expose() delivery_street1: string = '';
  @Expose() delivery_street2: string = '';
  @Expose() delivery_city: string = '';
  @Expose() delivery_zip: string = '';
  @Expose() fail_reason: string = '';
  @Expose() time_failed: string = '';
  @Expose() time_closed: string = '';
  @Expose() fired: boolean = false;
  @Expose() status: string = '';
  @Expose() items: string = '';
  @Expose() products: BasketProduct[];
  @Expose() card_number: string = '';
  @Expose() delivery_instructions: string = '';
  @Expose() adjustment_type: string = '';
  @Expose() adjustment_reason: string = '';
  @Expose() time_adjusted: string = '';
  @Expose() fees_total: number = 0;
  @Expose() client_platform: string = '';
  @Expose() car_make: string = '';
  @Expose() car_model: string = '';
  @Expose() car_color: string = '';
  @Expose() license_plate: string = '';
  @Expose() arrived: boolean = false;
  @Expose() arrived_at: string = '';
  @Expose() vendorid: number = 0;
  @Expose() vendorname: string = '';

  constructor(
    order_guid: string,
    order_id: string,
    oloid: string,
    store_number: number,
    time_placed: string,
    time_wanted: string,
    time_ready: string,
    readytime: string,
    customerhandoffcharge: number,
    delivery_method: string,
    deliverymode: string,
    num_items: number,
    subtotal: number,
    tax: number,
    taxes: TaxInterface[],
    tip: number,
    delivery: number,
    discount: number,
    total: number,
    customer_delivery: number,
    payment_type: string,
    time_cancelled: string,
    cancel_reason: string,
    delivery_street1: string ,
    delivery_street2: string,
    delivery_city: string,
    delivery_zip: string,
    fail_reason: string ,
    time_failed: string,
    time_closed: string,
    fired: boolean,
    status: string,
    items: string,
    products: BasketProduct[],
    card_number: string,
    delivery_instructions: string,
    adjustment_type: string,
    adjustment_reason: string,
    time_adjusted: string,
    fees_total: number,
    client_platform: string,
    car_make: string,
    car_model: string,
    car_color: string,
    license_plate: string,
    arrived: boolean,
    arrived_at: string,
    vendorid: number,
    vendorname: string
  ) {
    this.order_guid = order_guid;
    this.order_id = order_id;
    this.oloid = oloid;
    this.store_number = store_number;
    this.time_placed = time_placed;
    this.time_wanted = time_wanted;
    this.time_ready = time_ready;
    this.readytime = readytime;
    this.customerhandoffcharge = customerhandoffcharge;
    this.delivery_method = delivery_method;
    this.deliverymode = deliverymode;
    this.num_items = num_items;
    this.subtotal = subtotal;
    this.tax = tax;
    this.taxes = taxes;
    this.tip = tip;
    this.delivery = delivery;
    this.discount = discount;
    this.total = total;
    this.customer_delivery = customer_delivery;
    this.payment_type = payment_type;
    this.time_cancelled = time_cancelled;
    this.cancel_reason = cancel_reason;
    this.delivery_street1 = delivery_street1;
    this.delivery_street2 = delivery_street2;
    this.delivery_city = delivery_city;
    this.delivery_zip = delivery_zip;
    this.fail_reason = fail_reason;
    this.time_failed = time_failed;
    this.time_closed = time_closed;
    this.fired = fired;
    this.status = status;
    this.items = items;
    this.products = products;
    this.card_number = card_number;
    this.delivery_instructions = delivery_instructions;
    this.adjustment_type = adjustment_type;
    this.adjustment_reason = adjustment_reason;
    this.time_adjusted = time_adjusted;
    this.fees_total = fees_total;
    this.client_platform = client_platform;
    this.car_make = car_make;
    this.car_model = car_model;
    this.car_color = car_color;
    this.license_plate = license_plate;
    this.arrived = arrived;
    this.arrived_at = arrived_at;
    this.vendorid = vendorid;
    this.vendorname = vendorname;
  }

  totalTaxes = ():number => {
    let totalTaxes = 0;

    if (this.taxes && this.taxes.length > 0) {
      this.taxes.forEach((taxItem) => {
        totalTaxes += taxItem.tax;
      })
    }

    return totalTaxes;
  }

  friendlyDeliveryMode = ():string => {
    let str = '';

    switch(this.deliverymode) {
      case 'curbside':
        str = 'Grab & Go';
        break;
      case 'dispatch':
        str = "Delivery"
        break;
      case 'pickup':
        str = "Counter Pickup"
        break;
      case 'curbside_real':
        str = "Curbside"
        break;
      case 'drivethru':
        str = "Drive-Thru"
        break;
      case 'dinein':
        str = "DDine In"
        break;
    }

    return str;
  }
}